var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMemory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 551.73 278.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#00a99d;stroke-linecap:round;stroke-miterlimit:10;stroke-width:7px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "auditory_memory",
    "data-name": "auditory memory"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M532.66,135a29.51,29.51,0,0,1-29.5,29.5h-.65a29.33,29.33,0,0,1-14.73-4.32,37.05,37.05,0,0,0-14.08-23.5c0-.55-.05-1.11-.05-1.67a29.52,29.52,0,0,1,44.13-25.64c.37.21.73.43,1.09.65h0a29.51,29.51,0,0,1,13.77,23.79C532.66,134.18,532.66,134.57,532.66,135Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.12,236.23v32.49c-48.39,20.5-103.06.95-103.06.95V236.23a35.3,35.3,0,0,1,11.2-25.62,38.86,38.86,0,0,1,22.95-10.47h0a37.08,37.08,0,0,0,12.47,3.06c.81,0,1.62.07,2.44.07s1.63,0,2.44-.07A36.81,36.81,0,0,0,466.5,200H467C488,200,505.12,216.27,505.12,236.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.73,204.4v32.49a119.4,119.4,0,0,1-34.83,8.63v-1.78a52.79,52.79,0,0,0-.48-7.15,54.56,54.56,0,0,0-9.55-24.23,57,57,0,0,0-6.67-7.89,59.82,59.82,0,0,0-13.94-10.25,58.14,58.14,0,0,0-7.45-3.35,36.78,36.78,0,0,0,9.4-22.75h25.4a36.18,36.18,0,0,1,3.63.17C536.52,170,551.73,185.61,551.73,204.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.12,236.23v32.49c-48.39,20.5-103.06.95-103.06.95V236.23a35.3,35.3,0,0,1,11.2-25.62,38.86,38.86,0,0,1,22.95-10.47h0a37.08,37.08,0,0,0,12.47,3.06c.81,0,1.62.07,2.44.07s1.63,0,2.44-.07A36.81,36.81,0,0,0,466.5,200H467C488,200,505.12,216.27,505.12,236.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.23,164.48a29.51,29.51,0,0,1-28.53-23.2A37.89,37.89,0,0,1,49.23,164.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532,141.11a29.42,29.42,0,0,1-10.28,16.77c-1.25-.2-2.52-.37-3.79-.49-1.54-.14-3.09-.21-4.67-.21h-6.93a36.38,36.38,0,0,1,5-5.91A38.68,38.68,0,0,1,532,141.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.46,195.61c-.44,0-.89,0-1.33,0s-.89,0-1.33,0a29.5,29.5,0,0,1-28.07-27,38,38,0,0,1,29.4,23A32.89,32.89,0,0,1,452.46,195.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.83,192.86a47.19,47.19,0,0,0-20.94,11.52,43.08,43.08,0,0,0-13.66,31.24v10.1A171.54,171.54,0,0,1,0,237.84V204.4a35.31,35.31,0,0,1,11.2-25.62,38.91,38.91,0,0,1,25.73-10.64l1.2,0H63.52A36.93,36.93,0,0,0,74.83,192.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.59,204.4v32.49c-1.17.5-2.35,1-3.53,1.42-16.23,6.2-33,8.11-48,7.93v-10a35.3,35.3,0,0,1,11.2-25.62,38.86,38.86,0,0,1,22.95-10.47h0a37.08,37.08,0,0,0,12.47,3.06c.81,0,1.62.07,2.44.07s1.63,0,2.44-.07C453.59,203.6,453.59,204,453.59,204.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.53,168.61a29.5,29.5,0,0,1-28.07,27c-.44,0-.89,0-1.33,0s-.89,0-1.33,0a36.76,36.76,0,0,1,1.33-4,36.27,36.27,0,0,1,8.74-12.83A38.71,38.71,0,0,1,480.53,168.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.12,236.23v10a178.33,178.33,0,0,1-55.06-7.92c-.92-.3-1.39-.47-1.39-.47V204.4c0-.4,0-.8,0-1.2.81,0,1.62.07,2.44.07s1.63,0,2.44-.07A36.81,36.81,0,0,0,466.5,200H467C488,200,505.12,216.27,505.12,236.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.73,204.4v32.49a119.4,119.4,0,0,1-34.83,8.63l-.48.06v-10A42.21,42.21,0,0,0,510,213.18a45.29,45.29,0,0,0-9.75-11.07,46.82,46.82,0,0,0-13.94-7.89,47.87,47.87,0,0,0-8.51-2.2c.37-.38.72-.76,1.06-1.15a36.78,36.78,0,0,0,9.4-22.75h25.4a36.18,36.18,0,0,1,3.63.17C536.52,170,551.73,185.61,551.73,204.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.12,236.23v32.49c-48.39,20.5-103.06.95-103.06.95V236.23a35.3,35.3,0,0,1,11.2-25.62,38.86,38.86,0,0,1,22.95-10.47h0a37.08,37.08,0,0,0,12.47,3.06c.81,0,1.62.07,2.44.07s1.63,0,2.44-.07A36.81,36.81,0,0,0,466.5,200H467C488,200,505.12,216.27,505.12,236.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.36,236.23v32.49c-48.39,20.5-103.06.95-103.06.95V236.23a35.3,35.3,0,0,1,11.2-25.62,38.86,38.86,0,0,1,23-10.47h0a37.08,37.08,0,0,0,12.47,3.06c.81,0,1.62.07,2.44.07s1.63,0,2.44-.07A36.81,36.81,0,0,0,113.74,200h.51C135.21,200,152.36,216.27,152.36,236.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.81,107.71a29.49,29.49,0,0,1-26.23,1.81,29.58,29.58,0,0,1,26.23-1.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79,135c0,.31,0,.63,0,.94a37.1,37.1,0,0,0-15.17,24.85,29.38,29.38,0,0,1-14.32,3.71h-.3A29.5,29.5,0,0,1,20,135c0-.15,0-.3,0-.45a29.33,29.33,0,0,1,2.55-11.59l0,0a28.19,28.19,0,0,1,3.14-5.4v0a29.56,29.56,0,0,1,8.81-8l0,0A29.52,29.52,0,0,1,79,135Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.66,135a29.51,29.51,0,0,1-29.5,29.5h-.65a29.33,29.33,0,0,1-14.73-4.32,37.05,37.05,0,0,0-14.08-23.5c0-.55-.05-1.11-.05-1.67a29.52,29.52,0,0,1,44.13-25.64c.37.21.73.43,1.09.65h0a29.51,29.51,0,0,1,13.77,23.79C532.66,134.18,532.66,134.57,532.66,135Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.64,166.14c0,.84,0,1.66-.11,2.47a29.5,29.5,0,0,1-28.07,27c-.44,0-.89,0-1.33,0s-.89,0-1.33,0a29.5,29.5,0,0,1-28.07-27c-.06-.81-.1-1.63-.1-2.47a29.51,29.51,0,1,1,59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.34,166.14c0,.84,0,1.66-.11,2.47a29.5,29.5,0,0,1-28.07,27c-.44,0-.89,0-1.33,0s-.89,0-1.33,0a29.5,29.5,0,0,1-28.07-27c-.06-.81-.1-1.63-.1-2.47a29.51,29.51,0,1,1,59,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.66,69.82A39.46,39.46,0,0,0,250,4.57a38,38,0,0,0-3.6,2.15c-.93.62-1.81,1.28-2.66,2a39.45,39.45,0,0,0-9,51.3c.31.5.62,1,1,1.5s.67,1,1,1.45a39.47,39.47,0,0,0,50.91,11c1-.53,1.9-1.11,2.83-1.73C291.57,71.47,292.64,70.66,293.66,69.82ZM282.47,71C273.38,74,264.73,72.73,263.14,68S267.62,57,276.71,54s17.75-1.76,19.34,2.93S291.56,67.88,282.47,71Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.48,77.62a32.35,32.35,0,1,1-64.7,0,32.35,32.35,0,1,1,64.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.18,77.62a32.31,32.31,0,1,1-1.12-8.47A32.18,32.18,0,0,1,133.18,77.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.78,109.34c.37.21.73.43,1.09.65l-.93.33a29.54,29.54,0,0,1-24.86-3.08,29.57,29.57,0,0,1,24.7,2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.36,69.15A32.46,32.46,0,0,1,480.6,91a29.56,29.56,0,0,1,1.76-21.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6,122.92a28.19,28.19,0,0,1,3.14-5.4A29.28,29.28,0,0,1,22.6,122.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.56,113.34a30.11,30.11,0,0,1,6.8,20.3s17.65-9,30.95-.91c0,0,1.5-15.16,7-19.39C474.28,113.34,449.87,111.23,429.56,113.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.48,113.34a30.13,30.13,0,0,1,6.79,20.3s17.66-9,31-.91c0,0,1.49-15.16,7-19.39C123.19,113.34,98.78,111.23,78.48,113.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.63,
    y: 86.71,
    width: 84.99,
    height: 138.08,
    rx: 6.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.4,
    y: 126.86,
    width: 129.77,
    height: 21.95,
    rx: 10.97,
    transform: "translate(-36.34 194.35) rotate(-48.16)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280.39,
    y: 128.94,
    width: 135.34,
    height: 21.95,
    rx: 10.97,
    transform: "translate(220.09 -212.71) rotate(48.16)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "soundwave3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M210.2,68.4S182.41,55,202.52,34.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.46,78.37S161.22,58.9,190.33,29.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.17,19.81C168.41,27.72,164,35.14,161.89,42c-4.43,14.62,1.91,26.65,10,35.36A79,79,0,0,0,192.73,93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "soundwave3-2",
    "data-name": "soundwave3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M323.17,68.4S351,55,330.85,34.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M331.91,78.37S372.15,58.9,343,29.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.2,19.81C365,27.72,369.41,35.14,371.48,42c4.43,14.62-1.91,26.65-10,35.36A79,79,0,0,1,340.64,93"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMemory);
export default __webpack_public_path__ + "static/media/ic_memory.f87fd9ec729224d42e305d9941699976.svg";
export { ForwardRef as ReactComponent };